module.exports = __webpack_public_path__ + "img/dashboard_myorders.82930d4c.svg";